import { Component, Input, OnInit, OnChanges } from '@angular/core'
import { trigger, state, style, transition, animate } from '@angular/animations';
import { Performer } from 'src/app/store/performers.era';
import { LabelObject, Ranking } from 'globals/store/events.data';
import { Dictionary } from '@ngrx/entity';
import publicHelpers from 'globals/helpers/public-helpers';
import { CommonModule } from '@angular/common';
import { MenuHoverButtonComponent } from '../buttons/menu-hover-button.component';
import { InitialsPipe } from 'src/app/services/pipes/initials.pipe';
import { LabelsViewComponent } from '../label-marker/labels-view.component';
import { SocialLinksComponent } from '../social-links/social-links.component';
import { ExpandIconComponent } from '../icon/expand.icon.component';

@Component({
    selector: 'static-performer-cards',
    templateUrl: './static-performer-cards.html',
    styleUrls: ['./static-performer-cards.scss'],
    animations: [
        trigger('drop', [
            state('expand', style({ height: '*' })),
            state('collapse, undefined, void', style({ height: '0', padding: 0 })),
            transition('* => *', [animate('300ms')]),
            transition('void => *', [animate('0ms')])
        ])
    ],
    standalone: true,
    imports: [CommonModule, ExpandIconComponent, SocialLinksComponent, LabelsViewComponent, MenuHoverButtonComponent, InitialsPipe],
})
export class StaticPerformerCardsComponent implements OnInit, OnChanges {
  @Input() allExpanded // can be overwritten for printing
  @Input() performerIds: string[]
  @Input() performers: { [pId: string]: Performer }
  @Input() condensedPerformers = false
  @Input() labelMap: LabelObject
  @Input() hidePerformersHeading = false
  @Input() narrowPerformersHeading = false
  @Input() performerRoles: Dictionary<Ranking>
  @Input() performerRoleIds: Dictionary<string>

  expanded: { [performerId:string]: boolean } = {}
  helpers = publicHelpers
  hide = true

  ngOnInit() {
    this.toShowOrNotToShow()
  }

  toShowOrNotToShow() {
    this.hide = !this.performerIds || !this.performers || !this.performerIds.filter(pId => !!this.performers[pId]).length
  }

  expand(event, performerId){
    if(event.stopPropagation) event.stopPropagation();
    this.expanded[performerId] = !this.expanded[performerId]
  }

  ngOnChanges(_) {
    setTimeout(() => this.toShowOrNotToShow(), 0) // simpler than dealing with the changes by name;  this is a small contained component so this should be okay
  }

}

